<template>
  <div class="container mt-40">
    <div
      id="success-overlay"
      class="modal modal-sm modal-success"
      v-bind:class="{ 'is-active': isCardModalActive }"
    >
      <div class="modal-background scaleInCircle"></div>
      <div class="modal-content scaleIn">
        <div class="flex-card simple-shadow">
          <div class="card-body">
            <div class="content pb-20">
              <h2 class="has-text-centered pb-10">تنبيه</h2>
              <p>حجز موعد سحب نقدي</p>

              <hr />
              <a class="button btn-align btn-hero is-warning raised is-large">
                <b>تاريخ {{ customerdateformatted }}</b>
              </a>
              <br />
              <!-- 
              <a
                class="
                  button
                  btn-align btn-hero
                  is-warning
                  raised
                  is-large
                  mt-20
                "
              >
                <b>بتوقيت {{ customertime }}</b>
              </a> -->
            </div>
            <div class="mt-20">
              <a
                class="
                  button
                  is-info
                  raised
                  btn-align
                  is-large
                  modal-dismiss
                  is-bold
                  ml-10
                "
                v-bind:class="{ 'is-loading': isLoading }"
                @click="book()"
              >
                <b>تأكيد و حجز</b>
              </a>

              <a
                class="button is-dark btn-align modal-dismiss is-bold is-large"
                @click="isCardModalActive = false"
              >
                <b>عودة</b>
              </a>
            </div>
          </div>
        </div>
      </div>
      <button
        class="modal-close is-large"
        @click="isCardModalActive = false"
      ></button>
    </div>
    <!-- Hero image -->

    <div class="columns is-centered has-text-centered" v-if="isLoading">
      <loading
        line-fg-color="#2d3f51"
        size="massive"
        class="margin-100"
        spacing="55"
        text-fg-color="#fff"
        message="الرجاء الإنتظار"
      />
    </div>
    <div class="columns is-vcentered" v-else-if="!isEligible">
      <div class="column is-6 is-offset-3 mb-90">
        <!-- Login form -->
        <div class="flex-card raised padding-20">
          <div class="square-icon-box rounded danger mt-20">
            <div class="icon-box-wrapper">
              <div class="icon-box">
                <i class="material-icons">close</i>
              </div>
            </div>
          </div>
          <div class="animated preFadeInLeft fadeInLeft pb-90">
            <hr />

            <h1 class="subtitle is-5">
              عفواً لديك حجز مسبق لسحب نقدي بالفرع الخاص بك
            </h1>

            <div id="printMe">
              <router-link to="/" class="logo">
                <img
                  class
                  src="~/../../assets/images/logos/brand-logo.png"
                  width="25%"
                  alt
                />
              </router-link>
              <hr />
              <a class="button button-cta primary-btn is-bold is-large mt-20">
                <b>يوم {{ message.selected_date }}</b>
              </a>
              <br />

              <a class="button button-cta primary-btn is-bold is-large mt-20">
                <b>بتوقيت {{ message.selected_time }}</b>
              </a>
              <br />
              <a class="button button-cta primary-btn is-bold is-large mt-20">
                <b>رقم الحجز {{ message.id }}</b>
              </a>

              <hr />
              <!-- 
              <h4 class="title is-4">
                رجاء الالتزام بالحضور
                <span v-if="message.confirmation_messages">
                  و احضار معاكم التالي</span
                >
              </h4> -->

              <hr />

              <div v-if="message.confirmation_messages" class="mt-5 mb-10">
                <ul>
                  <li
                    v-for="conf_message in message.confirmation_messages"
                    :key="conf_message"
                    class="title is-4"
                  >
                    {{ conf_message }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div
          class="
            hero-foot
            has-text-centered
            mt-40
            mb-40
            animated
            preFadeInUp
            fadeInUp
          "
        >
        <a class="button button-cta danger-btn is-bold is-medium my-20 ml-20" v-if="cantCancel" @click="cancel( message.id ,'حجز موعد سحب نقدي')">
                <b> الغاء الحجز </b>
              </a>
          <a
            class="
              button
              is-info
              btn-align
              modal-dismiss
              is-bold is-medium
              ml-20
            "
            @click="print"
          >
            <b>طباعة</b>
          </a>
          <a
            class="button is-dark btn-align modal-dismiss is-bold is-medium"
            @click="$router.go('-1')"
          >
            <b>العودة</b>
          </a>
        </div>
      </div>
    </div>
    <div class="columns is-vcentered" v-else-if="isEligible && calanderfail">
      <div class="column is-6 is-offset-3 mb-90">
        <!-- Login form -->
        <div class="flex-card raised padding-20">
          <div class="square-icon-box rounded danger mt-20">
            <div class="icon-box-wrapper">
              <div class="icon-box">
                <i class="material-icons">close</i>
              </div>
            </div>
          </div>
          <div class="animated preFadeInLeft fadeInLeft pb-90">
            <hr />

            <h1 class="subtitle is-5">{{ message }}</h1>

            <hr />
          </div>
        </div>
        <div
          class="
            hero-foot
            has-text-centered
            mt-40
            mb-40
            animated
            preFadeInUp
            fadeInUp
          "
        >
          <a
            class="button is-dark btn-align modal-dismiss is-bold is-medium"
            @click="$router.go('-1')"
          >
            <b>العودة</b>
          </a>
        </div>
      </div>
    </div>
    <div class="hero-body" v-else>
      <div class="container has-text-centered pb-90">
        <div class="columns">
          <div class="column is-6 is-offset-3">
            <!-- Login form -->
            <div class="animated preFadeInLeft fadeInLeft pb-90">
              <hr />
              <h1 class="title is-4">حجز موعد سحب نقدي</h1>

              <b-message v-if="message != ''" title="تنبيه" type="is-info">
                <b>{{ message }}</b>
              </b-message>

              <hr />

              <v-date-picker
                v-model="customerdate"
                locale="ar"
                :popover="{ placement: 'bottom', visibility: 'click' }"
                :first-day-of-week="1"
                :disabled-dates="{ weekdays: offDays }"
                :input-props="{
                  readonly: true,
                }"
                :min-date="minDate"
                :max-date="maxDate"
              >
                <b-field
                  :expanded="true"
                  label="تاريخ مقابلة"
                  size="is-large"
                  class="is-fullwidth"
                >
                  <b-input
                    readonly
                    type="text"
                    size="is-large "
                    class="text-ccenter"
                    :value="customerdateformatted"
                    placeholder="اختر تاريخ"
                    expanded
                  ></b-input>
                </b-field>
              </v-date-picker>

              <hr />
              <div
                class="columns has-text-centered is-centered"
                v-if="slotsloading"
              >
                <loading
                  line-fg-color="var(--primary-color)"
                  size="large"
                  class="margin-100"
                  text-fg-color="#2d3f51"
                  message="الرجاء الإنتظار"
                />
              </div>

              <div
                class="field-body is-loading"
                v-else-if="customerdateformatted != null"
              >
                <div class="table is-fullwidth mb-40">
                  <div v-if="timeslot.Status != 'false'">
                    <div data-th="Role">
                      <a
                        class="button info-btn is-medium"
                        @click="selectTime(timeslot.StartTime)"
                        :class="{
                          'is-disabled ': timeslot.Status == 'false',
                        }"
                      >
                        <b v-if="timeslot.Status == 'true'">حجز</b>
                        <b v-else>لايمكن حجز</b>
                      </a>
                    </div>
                  </div>
                  <div v-else>
                    <b-message
                      v-if="message != ''"
                      title="تنبيه"
                      type="is-danger"
                    >
                      <b>عفواً لايمكن الحجز هذا اليوم</b>
                    </b-message>
                  </div>
                </div>
              </div>
              <div v-else class="container pt-90 pb-90">
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
              </div>
              <div v-if="checkIfWeekend(customerdate)">
                عفواً لايمكن حجز يوم جمعة او السبت
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import arabic from "vee-validate/dist/locale/ar";
import moment from "moment";

const min = new Date();
min.setHours(9);
min.setMinutes(0);
const max = new Date();
max.setHours(18);
max.setMinutes(0);
export default {
  name: "book",
  data() {
    return {
      code: "",
      info: "",
      local: "ar",
      message: "",
      messagetype: "is-info",
      slotsloading: false,
      offDays: [],
      isLoading: false,
      minTime: min,
      maxTime: max,
      date: null,
      minDate: null,
      maxDate: null,
      isLoading: false,
      isFullPage: true,
      timeslots: null,
      message: "",
      calanderloading: false,
      workCalendarId: "",
      customerdate: null,
      customertime: null,
      isCardModalActive: false,
      isEligible: false,
      reason_id: "",
      calanderfail: false,
      timeslot:null
    };
  },
  methods: {
    dateformat(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    openLoading() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 10 * 1000);
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.verifiy();
          return;
        }
      });
    },
    print() {
      // Pass the element id here
      this.$htmlToPaper("printMe");
    },
    book() {
      this.isLoading = !this.isLoading;
      var fixinfo = {
        customer_id: this.customer_id,
        branch_id: this.info.Branch_id,
        selected_date: this.customerdateformatted,
        selected_time: this.customertime,
        reason: this.reason_id,
      };

      axios
        .post("/scheduler/reserve_v2", {
          customer_id: this.customer_id,
          branch_id: this.info.Branch_id,
          selected_date: this.customerdateformatted,
          selected_time: this.customertime,
          reason: this.reason_id,
        })
        .then((response) => {
          // this.$router.push("/");

          // console.log("----------------------");

          // console.log(response.data);

          // console.log("----------------------");

          if (response.data.status === "success") {
            this.$router.push({
              name: "withdrawalbookingsuccess",
              params: {
                customer_id: this.customer_id,
                customerdate: this.customerdateformatted,
                customertime: this.customertime,
                id: response.data.id,
                confirmation_messages: response.data.confirmation_messages,
              },
            });
          }
          if (response.data.status === "fail") {
            this.customertime = null;
            this.gettimeslots();
            this.message = response.data.message;
            this.isCardModalActive = false;
            // this.$router.push("/");
          }
          this.isLoading = !this.isLoading;
        })
        .catch((error) => {
          this.isLoading = !this.isLoading;
          console.log(error);
          this.message = error.message;
        });
    },
    gettimeslots() {
      var info = {
        work_calendar_id: this.workCalendarId,
        selected_date: moment(this.customerdate)
          .format("YYYY-MM-DD")
          .toString(),
        reason: this.reason_id,
      };

      this.slotsloading = true;
      axios
        .post("/scheduler/getSlotsOfADay_v2", info)
        .then((response) => {
          console.log("request payload:");

          // console.log(info);
          // console.log("------------------");

          // console.log("response:");

          console.log(response.data.Slots);
          this.timeslots= null
          // this.timeslots = response.data.Slots;
 

          for (var i = 0; i < response.data.Slots.length; i++) {
            // var currentTime = moment();
            // var endTime = moment(this.timeslots[i].StartTime, "HH:mm");

            if ((response.data.Slots[i].Status == "true")) {
              var slot = response.data.Slots[i];

          
              this.timeslot = slot;
              break;
            }

                     if(i == response.data.Slots.length-1){
 var slot = response.data.Slots[i];

          
              this.timeslot = slot;
              break;
          }
          }

 

          // this.timeslots.map((obj) => {
          //   var currentTime = moment();
          //   var endTime = moment(obj.StartTime, "HH:mm");

          //   if (
          //     currentTime.isAfter(endTime) &&
          //     currentTime == moment(this.customerdate)
          //   ) {
          //     obj.Status = "false";
          //   }

          //   if( obj.Status = "true"){
          //       // break;
          //   }

          //   return obj;
          // });

          this.slotsloading = false;
          // console.log(response);
          // if (response.data.status === "success") {
          //       return
          // } else if (response.data.status === "fail") {

          // }
        })
        .catch((error) => {
          console.log(error);
        });
      // console.log('x22xx');
    },
    selectTime(time) {
      console.log(time);
      this.customertime = time;
      // this.isCardModalActive = true;
      this.book();
    },
    checkIfWeekend(date) {
      return (
        moment(this.customerdate).day() == 6 ||
        moment(this.customerdate).day() == 5
      );
    },
    CalcOffDays(days) {
      days.saturday == false ? this.offDays.push(7) : null;
      days.friday == false ? this.offDays.push(6) : null;
      days.thursday == false ? this.offDays.push(5) : null;
      days.wednesday == false ? this.offDays.push(4) : null;
      days.tuesday == false ? this.offDays.push(3) : null;
      days.monday == false ? this.offDays.push(2) : null;
      days.sunday == false ? this.offDays.push(1) : null;

      console.log(this.offDays);
    },
    cancel( id, string) {
 

 console.log("url:" + this.cancelurl);

 this.$dialog.confirm({
   message: "هل انت متأكد من الغاء  " + string + " ذو الرقم " + id,
   cancelText: "لا",
   confirmText: "نعم",
   type: "is-danger",
   onConfirm: () =>
     this.$router.push({
       name: "cancelrequest",
       params: {
         requeststring: string,
         requestid: id,
         requesturl: 'https://test-be.wahda.ly/wahdagateway/v1/scheduler/appointment/delete/'
       }
     })
 });
}
  },
  watch: {
    customerdate: function () {
      if (
        this.customerdate != null &&
        this.customerdate != "" &&
        moment(this.customerdate).day() != 6 &&
        moment(this.customerdate).day() != 5
      ) {
        this.gettimeslots();
      }
    },
  },
  computed: {
    customerdateformatted: function () {
      if (this.customerdate != null)
        return moment(this.customerdate).format("YYYY-MM-DD");
      else return null;
    },
    cantCancel: function () {
  
      return moment(this.message.selected_date) > moment();
  
    },
  },

  mounted() {
    moment.locale("en");

    this.isLoading = true;

    var user = JSON.parse(localStorage.getItem("user"));
    this.customer_id = user[1];
    axios
      .get("/reasons/system/name/withdrawal")
      .then((response) => {
        this.reason_id = response.data.message.id;

        axios
          .post("/customer/book/isEligible", {
            customer_id: user[1],
            reason: this.reason_id,
          })
          .then((response) => {
            this.isLoading = true;
            // alert(response.data.message);

            if (response.data.status == "fail") {
              this.isLoading = false;
              // alert(123);

              this.message = response.data.message;
              // this.message.confirmation_messages = [ 'test1' , 'test2'];

              this.isEligible = false;
            } else {
              this.isEligible = true;
              axios
                .get("/customer/basicData/" + user[1])
                .then((response) => {
                  console.log(response.data);

                  this.$root.kick(response.data.message);
                  this.info = response.data.result;
                  this.userid = user[1];
                  this.isLoading = false;

                  this.calanderloading = true;

                  axios
                    .post("/scheduler/getCurrentWC_v2/", {
                      branch_id: this.info.Branch_id,
                      reason: this.reason_id,
                    })
                    .then((response) => {
                      if (response.data.status == "fail") {
                        this.isLoading = false;
                        // alert(123);

                        this.calanderfail = true;
                        this.message = response.data.message;
                      } else {
                        console.log(response);
                        this.CalcOffDays(response.data.data);
                        this.isLoading = false;

                        if (
                          moment(response.data.data.start_day).toDate() <=
                          moment().toDate()
                        ) {
                          this.minDate = moment().toDate();
                        } else {
                          this.minDate = moment(
                            response.data.data.start_day
                          ).toDate();
                        }
                        this.maxDate = moment(
                          response.data.data.end_day
                        ).toDate();
                        this.workCalendarId = response.data.data.id;
                        this.calanderloading = false;

                        this.message =
                          " الحجوزات مفتوحة من " +
                          this.dateformat(
                            moment(response.data.data.start_day).toDate()
                          ) +
                          " الى " +
                          this.dateformat(this.maxDate);

                        console.log("22" + this.message);
                      }
                    })
                    .catch((error) => {
                      // this.$router.push('/');
                    });
                  this.$validator.localize("ar", {
                    messages: arabic.messages,
                    attributes: {
                      code: "كود التفعيل",
                    },
                  });
                })
                .catch((error) => {
                  // console.log(error);
                  // this.$router.push('/');
                });
            }
          });
      })
      .catch((error) => {
        // this.$router.push('/');
      });
  },
};
</script>
